import React from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import PageHeader from "../../components/PageHeader";
import mainHelper, {
  apiCall, formattedPrice,
  getBranches,
  getCustomers,
  getEmployes,
  getStatus,
  getTypes
} from "../../helpers/MainHelper";
import ReactLoading from "react-loading";
import withPermissions from "../../components/WithPermissions";
import { setCostPriceData, setProfitData } from "../../actions";
import CostPriceDataChart from "../../components/Charts/CostPriceDataChart";
import ProfitsDataChart from "../../components/Charts/ProfitsDataChart";
import Select from "react-select";
import './FinanceReports.css';


class FinanceReports extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      costPriceData: [],
      profitData: [],
      totals: [],
      branches: [],
      customers: [],
      status: [],
      employes: [],
      type: [],
      selectedCustomer: [],
      formData: {
        startDateTime: '',
        endDateTime: '',
        by_customer: '',
        by_branch: '',
        by_employee: '',
        by_service_type: '',
        by_service_status: '',
      },
      loading: false,
      isLoad: true,

    }
  }
  componentDidMount() {
    this.getReports();
    /*const now = new Date();
    const localDateTime = new Date(now.getTime() - (now.getTimezoneOffset() * 60000))
        .toISOString()
        .slice(0, 16);
    this.setState( prevState => ({
        formData : {
          ...prevState.formData,
          startDateTime:localDateTime
        }
    }));*/
  }
  getReports = async () => {

    try {
      const response = await apiCall('business/reports/finance', 'post', null);
      const branches = await getBranches();
      const employes = await getEmployes();
      const types = await getTypes();
      const status = await getStatus();
      const customers = await getCustomers();
      this.setState({
        costPriceData: response.serviceCosts,
        profitData: response.profits,
        totals: response.totals,
        branches, employes, types, status, customers
      }, () => {
        this.props.setCostPriceData(response.serviceCosts);
        this.props.setProfitData(response.profits);
        this.setState({ isLoad: false });
      });

    }
    catch (e) {
      this.setState({ isLoad: false });
      console.log(e);
    }
  }

  handleChange = (e) => {
    const { id, value } = e.target;
    const formData = { ...this.state.formData };
    formData[id] = value;
    this.setState({ formData });
  };
  handleCustomerChange = (selectedCustomer) => {
    const formattedSelectedOptions = {
      value: selectedCustomer.value,
      label: selectedCustomer.label,
    };
    this.setState((prevState) => ({

      formData: {
        ...prevState.formData,
        by_customer: formattedSelectedOptions.value
      },
      selectedCustomer: formattedSelectedOptions
    }));

  };
  handleSubmit = async (e) => {
    e.preventDefault();

    this.setState({ loading: true });
    const { formData } = this.state;
    const reportFormData = new FormData();
    Object.keys(formData).forEach(key => {
      reportFormData.append(key, formData[key]);
    });
    try {
      const response = await apiCall('business/reports/finance', 'post', reportFormData);
      this.setState({
        costPriceData: response.serviceCosts,
        profitData: response.profits,
        totals: response.totals,
      }, () => {
        this.props.setCostPriceData(response.serviceCosts);
        this.props.setProfitData(response.profits);
        this.setState({ isLoad: false });
      });
      this.setState({ loading: false });
      mainHelper.toastMessage(response.status, response.message);
    } catch (e) {
      this.setState({ loading: false });
    }

  }
  render() {
    const {
      loading,
      isLoad,
      costPriceData,
      profitData,
      branches,
      employes,
      types,
      status,
      customers,
      totals,
      selectedCustomer
    } = this.state;
    const customerFormattedOptions = customers
      .filter(option => option.is_supplier === 0)
      .map(option => ({
        value: option.id,
        label: option.name + ' ' + (option.surname || "")
      }));

    // Calculate profit margin
    const profitMargin = totals.total_price > 0
      ? ((totals.total_profit / totals.total_price) * 100).toFixed(1)
      : 0;
    const missingCostCount = totals.missing_cost_count || 0;
    return (
      <div
        style={{ flex: 1 }}
        onClick={() => {
          document.body.classList.remove("offcanvas-active");
        }}
      >
        <div>
          <div className="page-loader-wrapper" style={{ display: this.state.isLoad ? 'block' : 'none' }}>
            <div className="loader" style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
              <div className="m-t-30">
                <img src={require('../../assets/images/logo-white.png')} width="150" alt="Lucid" />
              </div>
              <p>Yükleniyor</p>
              <ReactLoading type="spin" width={'24px'} height={'24px'} color="#ffffff" />
            </div>
          </div>
          <div className="container-fluid">
            <PageHeader
              HeaderText="Raporlar"
              Breadcrumb={[
                { name: "Raporlar", navigate: "" },
              ]}
            />
            <div className="row clearfix">
              <div className="col-lg-12">
                <div className="card">
                  <form onSubmit={this.handleSubmit}>
                    <div className="body">
                      <div className="row clearfix">
                        <div className="col-lg-3">
                          <div className="form-group">
                            <label htmlFor="startDateTime" className="font-weight-bold text-cyan">
                              Başlangıç Tarihi
                            </label>
                            <input
                              id="startDateTime"
                              className="form-control"
                              type="datetime-local"
                              onChange={this.handleChange}
                            />
                          </div>
                        </div>
                        <div className="col-lg-3">
                          <div className="form-group">
                            <label htmlFor="endDateTime" className="font-weight-bold text-cyan">
                              Bitiş Tarihi
                            </label>
                            <input
                              id="endDateTime"
                              className="form-control"
                              type="datetime-local"
                              onChange={this.handleChange}
                            />
                          </div>
                        </div>
                        <div className="col-lg-3">
                          <div className="form-group">
                            <label htmlFor="by_branch" className="font-weight-bold text-cyan">
                              Şube
                            </label>
                            <select name="by_branch" id="by_branch" className="form-control"
                              onChange={this.handleChange}>
                              <option value="">Seçiniz</option>
                              {branches && branches.map((branch) => (
                                <option key={branch.id} value={branch.id}>
                                  {branch.name}
                                </option>
                              ))}
                            </select>
                          </div>
                        </div>
                        <div className="col-lg-3">
                          <div className="form-group">
                            <label htmlFor="by_customer" className="font-weight-bold text-cyan">
                              Müşteri
                            </label>
                            <Select
                              id="customer"
                              placeholder="Müşteri Seçiniz..."
                              options={customerFormattedOptions}
                              value={selectedCustomer}
                              onChange={this.handleCustomerChange}
                            />
                          </div>
                        </div>
                        <div className="col-lg-3">
                          <div className="form-group">
                            <label htmlFor="by_service_status" className="font-weight-bold text-cyan">
                              Servis Durumu
                            </label>
                            <select name="by_service_status" id="by_service_status" className="form-control"
                              onChange={this.handleChange}>
                              <option value="">Seçiniz</option>
                              {status && status.map((statu) => (
                                <option key={statu.id} value={statu.id}>
                                  {statu.name}
                                </option>
                              ))}
                            </select>
                          </div>
                        </div>
                        <div className="col-lg-3">
                          <div className="form-group">
                            <label htmlFor="by_service_type" className="font-weight-bold text-cyan">
                              Servis Tipi
                            </label>
                            <select name="by_service_type" id="by_service_type" className="form-control"
                              onChange={this.handleChange}>
                              <option value="">Seçiniz</option>
                              {types && types.map((type) => (
                                <option key={type.id} value={type.id}>
                                  {type.name}
                                </option>
                              ))}
                            </select>
                          </div>
                        </div>
                        <div className="col-lg-3">
                          <div className="form-group">
                            <label htmlFor="by_employee" className="font-weight-bold text-cyan">
                              Çalışan
                            </label>
                            <select name="by_employee" id="by_employee" className="form-control"
                              onChange={this.handleChange}>
                              <option value="">Seçiniz</option>
                              {employes && employes.map((employee) => (
                                <option key={employee.id} value={employee.id}>
                                  {employee.name + ' ' + employee.surname}
                                </option>
                              ))}
                            </select>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="body">
                      <div className="col-lg-12 d-flex justify-content-center">
                        <div className="col-lg-4">
                          <div className="form-group">
                            {loading ? (
                              <button className="btn btn-outline-primary btn-sm btn-block" disabled={true}
                                style={{ textAlign: "-webkit-center" }}>
                                Lütfen Bekleyin...<ReactLoading type="spin" width={'24px'} height={'24px'}
                                  color="#268bd2"></ReactLoading>
                              </button>
                            ) :
                              <button
                                className="btn btn-outline-primary btn-sm btn-block"
                                type="submit">
                                Güncelle
                              </button>}
                          </div>
                        </div>
                      </div>

                    </div>
                  </form>

                  {/* Modern Finance Statistics Cards */}
                  <div className="body modern-finance-stats-section">
                    <div className="row clearfix">
                      {/* Total Revenue Card */}
                      <div className="col-lg-4 col-md-6 col-sm-12">
                        <div className="modern-finance-stat-card card-blue">
                          <div className="stat-icon-wrapper">
                            <i className="fa fa-usd" style={{ fontSize: '3rem', color: '#3498db' }}></i>
                          </div>
                          <div className="stat-content">
                            <h3 className="stat-title">Toplam Gelir</h3>
                            <div className="stat-value">{formattedPrice(totals.total_price || 0)}</div>
                            <p className="stat-subtitle">KDV hariç, indirim sonrası; varsayılan tamamlanan servisler</p>
                          </div>
                        </div>
                      </div>

                      {/* Total Cost Card */}
                      <div className="col-lg-4 col-md-6 col-sm-12">
                        <div className="modern-finance-stat-card card-red">
                          <div className="stat-icon-wrapper">
                            <i className="fa fa-file-text" style={{ fontSize: '3rem', color: '#e74c3c' }}></i>
                          </div>
                          <div className="stat-content">
                            <h3 className="stat-title">Toplam Maliyet</h3>
                            <div className="stat-value">{formattedPrice(totals.total_cost || 0)}</div>
                            <p className="stat-subtitle">
                              {missingCostCount > 0 ? `${missingCostCount} serviste maliyet girilmemiş` : 'Miktar dahil servis maliyeti'}
                            </p>
                          </div>
                        </div>
                      </div>

                      {/* Net Profit Card */}
                      <div className="col-lg-4 col-md-6 col-sm-12">
                        <div className="modern-finance-stat-card card-green">
                          <div className="stat-icon-wrapper">
                            <i className="fa fa-trophy" style={{ fontSize: '3rem', color: '#27ae60' }}></i>
                          </div>
                          <div className="stat-content">
                            <h3 className="stat-title">Net Kar</h3>
                            <div className="stat-value">{formattedPrice(totals.total_profit || 0)}</div>
                            <p className="stat-subtitle">Kar marjı: %{profitMargin}</p>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="body">
                    <div className="row clearfix">
                      <div className="col-lg-12 col-md-12">
                        <div className="card">
                          <div className="header">
                            <h2>Aylık Kâr Verileri</h2>
                          </div>
                          {!isLoad ? (
                            profitData && Object.keys(profitData).length > 0 ? (
                              <ProfitsDataChart></ProfitsDataChart>
                            ) : (
                              <div className="alert alert-warning text-center">Veri yok</div>
                            )

                          ) : ""}
                        </div>
                      </div>
                      <div className="col-lg-12 col-md-12">
                        <div className="card">
                          <div className="header">
                            <h2>Maliyet Fiyat Verileri</h2>
                          </div>
                          {!isLoad ? (
                            costPriceData && Object.keys(costPriceData).length > 0 ? (
                              <CostPriceDataChart></CostPriceDataChart>
                            ) : (
                              <div className="alert alert-warning text-center">Veri yok</div>
                            )

                          ) : ""}
                        </div>
                      </div>
                    </div>

                  </div>

                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = ({ analyticalReducer }) => ({
  costPriceData: analyticalReducer.costPriceData,
  profitData: analyticalReducer.profitData,
});

export default withPermissions(withRouter(connect(mapStateToProps, {
  setCostPriceData,
  setProfitData
})(FinanceReports)));
